import grapesjs from 'grapesjs';
import loadComponents from './components';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('display-player-mp4-plugin', (editor, opts = {}) => {
  let c = opts;
  // Add components
  loadComponents(editor, c);
  //  // Add blocks
  loadBlocks(editor, c);
});



// WEBPACK FOOTER //
// ./src/plugins/player-mp4/index.js